import api from 'services/staff'

const state = {
    all: [],
    deleted: {},
    selected: {},
    pagination: [],
    totalPages: '',
    currentPage: '',
    status: null,
    statusMessage: null,
    roles: [],
    permissions: [],
    scheduleEmployeeIds: [],
    reminderEmployeeIds: []
}

const getters = {
    getStatus: state => state.status,
    getStatusMessage: state => state.statusMessage,
    getAllUsers: state => state.all,
    getAllUserCount: state => state.all.length,
    getDeletedUser: state => state.deleted,
    getSelectedUser: state => state.selected,
    totalPages(state) {
        return state.pagination.total_pages
    },
    currentPage(state) {
        return state.pagination.current_page
    },
    pagination(state) {
        return state.pagination
    },
    getRoles: state => state.roles,
    getPermissions: state => state.permissions,
    getScheduleEmployeeIds: state => state.scheduleEmployeeIds,
    getReminderEmployeeIds: state => state.reminderEmployeeIds
}

const mutations = {
    setUsers: (state, payload) => {
        state.all = payload.users
    },
    setRoles: (state, payload) => {
        state.roles = payload
    },
    setPermissions: (state, payload) => {
        state.permissions = payload
    },
    addUser: (state, payload) => {
        state.all.push(payload)
    },
    toggleActive: (state, payload) => {
        const user = state.all.find(user => {
            return user.id === payload.id
        })
        state.all.splice(state.all.indexOf(user), 1, payload)
    },
    selectUser: (state, payload) => {
        state.selected = payload
    },
    updateUser: (state, payload) => {
        if (payload.id) {
            state.status = 200
        } else {
            state.status = payload.status_code
            state.statusMessage = payload.errors
        }
        const user = state.all.find(user => {
            return user.id === payload.id
        })
        state.all.splice(state.all.indexOf(user), 1, payload)
    },
    deleteUser: (state, payload) => {
        const user = state.all.find(user => {
            return user.id === payload.id
        })
        if (user) {
            user.banned = true
        }
    },
    restoreUser: (state, payload) => {
        const user = state.all.find(user => {
            return user.id === payload.id
        })
        if (user) {
            user.banned = false
        }
    },
    permanentlyDeleteUser: (state, payload) => {
        state.all = state.all.filter(user => user.id !== payload.id)
    },
    deleteRole: (state, payload) => {
        const role = state.roles.find(role => {
            return role.id === payload.id
        })
        state.roles.splice(state.roles.indexOf(role), 1)
    },
    setFilterIds: (state, payload) => {
        state.scheduleEmployeeIds = payload.schedule_employee_ids || []
        state.reminderEmployeeIds = payload.reminder_employee_ids || []
    }
}

const actions = {
    async setUsers({commit}, query) {
        const payload = (await api.index(query)).data
        commit('setUsers', await payload)
    },
    async staffsList({commit}, query) {
        const payload = (await api.staffsList(query)).data
        commit('setUsers', await payload)
    },
    async managementList({commit}) {
        const payload = (await api.managementList()).data
        commit('setUsers', payload)
    },
    async selectUser({commit}, id) {
        const payload = (await api.showUser(id)).data
        commit('selectUser', await payload)
    },
    async deleteUser({commit}, user) {
        await api.deleteUser(user)
        commit('deleteUser', user)
    },
    async restoreUser({commit}, user) {
        await api.restoreUser(user)
        commit('restoreUser', user)
    },
    async permanentlyDeleteUser({commit}, user) {
        await api.permanentlyDeleteUser(user)
        commit('permanentlyDeleteUser', user)
    },
    async updateUser({commit, state}, query) {
        const payload = (await api.updateUser(state.selected.id, query)).data
        commit('updateUser', await payload)
    },
    async addUser({commit}, query) {
        await api.addUser(query)
        const payload = (await api.managementList()).data
        commit('setUsers', payload)
    },
    async toggleActive({commit, state}, id) {
        const payload = (await api.toggleActive(id)).data
        commit('toggleActive', await payload.user)
    },
    async fetchRoles({commit}, query) {
        const payload = (await api.roles(query)).data
        commit('setRoles', await payload)
    },
    async fetchPermissions({commit}, query) {
        const payload = (await api.permissions(query)).data
        commit('setPermissions', await payload)
    },
    async updatePermissions({commit, state}, data) {
        const payload = (await api.updatePermissions(data)).data
        commit('setRoles', await payload)
    },
    async createRole({commit}, query) {
        const payload = (await api.createRole(query)).data
        commit('setRoles', await payload)
    },
    async updateRole({commit}, query) {
        const payload = (await api.updateRole(query)).data
        commit('setRoles', await payload)
    },
    async deleteRole({commit}, role) {
        const payload = (await api.deleteRole(role)).data
        commit('deleteRole', role)
    },
    async fetchFilterIds({commit}) {
        const payload = (await api.staffsFilterIds()).data
        commit('setFilterIds', payload)
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
